import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import Img from '../../../../../../../src/components/shared/Img'
import { Modal } from '../../../../../shared/Modal'
import SvgIcon from '../../../../../shared/SvgIcon'
import HiddenIframe from '../../../../../shared/HiddenIframe'
import EnhancedVideoPlayer from 'src/components/shared/EnhancedVideoPlayer'

const ReviewItem = ({ item }) => {
  const [playVideo, setPlayVideo] = useState(false)
  const handleVideoPLaying = useCallback(() => {
    setPlayVideo((current) => !current)
  }, [setPlayVideo])

  return (
    <>
      <div
        className="relative px-4 lg:px-0"
        data-testid="freedom-debt-video-item"
      >
        <Img
          src={item.img.src}
          alt={item.img.alt}
          layout="fill"
          className="w-75 h-[415px]"
          objectFit="cover"
          imgClassName="md:object-top"
        />
        <div className="size-full z-50 bg-light-black">
          <div
            className="absolute bottom-0 left-0 z-50 px-6 pb-8 text-white"
            data-testid="freedom-debt-video-content"
          >
            <b
              className="text-23 leading-8"
              data-testid="freedom-debt-video-name"
            >
              <span>{item.name}</span>
              <span className="pb-3">*</span>
            </b>
            <div
              className="pt-2 pb-6 text-15 leading-6"
              data-testid="freedom-debt-video-stats"
            >
              <p data-testid="freedom-debt-video-graduate-date">
                Graduated {item.graduateDate}
              </p>
              <p data-testid="freedom-debt-video-enrolled-debt">
                Enrolled debt: {item.debt}
              </p>
              <p data-testid="freedom-debt-video-settled-accounts">
                Number of accounts settled: {item.settleNumber}
              </p>
            </div>
            <button
              className="flex flex-row rounded-lg bg-blue-575 px-2.5 py-3 text-white"
              onClick={handleVideoPLaying}
              data-testid="freedom-debt-video-play-button"
            >
              <SvgIcon name="play" className="size-5 my-auto mr-2 fill-white" />
              <b className="text-lg">Watch {item.pronoun} story</b>
            </button>
          </div>
        </div>
      </div>
      <HiddenIframe url={item.videoUrl} />
      {playVideo ? (
        <Modal
          open={playVideo}
          onClose={handleVideoPLaying}
          className="bg-black-base pt-9 pr-14 pb-4"
        >
          <EnhancedVideoPlayer
            src={item.videoLink}
            light={false}
            isInModal={true}
            className="lg:w-250 h-screen w-screen lg:h-[567px]"
          />
        </Modal>
      ) : null}
    </>
  )
}

export default ReviewItem

ReviewItem.propTypes = {
  item: PropTypes.object.isRequired,
}
